module.exports = __webpack_public_path__ + "img/stonesize-2@2x.58ade94.png";